const organizationMarkupSchema = () => {
  const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
  const APP_ID = process.env.APP_ID;
  const GOOGLE_PLAY_URL = process.env.GOOGLE_PLAY_URL;

  return {
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: 'Quran Pro',
    url: `${SITE_URL}`,
    logo: {
      '@type': 'ImageObject',
      inLanguage: 'en-US',
      url: `${SITE_URL}/logo/light.svg`,
      contentUrl: `${SITE_URL}/logo/light.svg`,
      caption: 'Quran Pro',
    },
    sameAs: [`https://apps.apple.com/us/app/id${APP_ID}`, GOOGLE_PLAY_URL],
  };
};

export default organizationMarkupSchema;
